import styled from "styled-components";
import { HorizontalLineSC } from "../DraggingTrackTranslated/styled";

interface TrackSCProps {
    top: string;
    height: string;
    shadow: string;
    layer: string | number;
    isactive?: string;
}

export const TrackSC = styled.div<TrackSCProps>`
    top: ${({ top }) => top};
    height: ${({ height }) => height};
    box-shadow: ${({ shadow }) => shadow};
    z-index: ${({ layer }) => layer};
    opacity: 0.81;
    color: #6e6e6e;
    background-color: #000dff;
    border-radius: 0.5em;
    transition:
        color 0.2s,
        background-color 0.2s,
        box-shadow 0.2s,
        opacity 0.2s;
    width: var(--audio-track-width);
    position: absolute;
    cursor: pointer;

    &:hover {
        ${HorizontalLineSC} {
            opacity: ${({ isactive }) => {
                if (isactive === "none" || isactive === "true") {
                    return 1;
                } else {
                    return 0;
                }
            }};
        }
    }
`;
